import type { ViewportSizes } from "@overmap-ai/blocks"
import { createContext } from "react"

type ViewportSizeContext = {
	// we don't need to include initial since its vacantly true
	[x in Exclude<ViewportSizes, "initial">]: boolean
} & {
	size: ViewportSizes
}

export const ViewportSizeContext = createContext<ViewportSizeContext>({} as ViewportSizeContext)
